//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


    import {page} from '@/api/flyback/flyback';
  	import {dateFormat} from '@/utils/common';

	export default {
		name:'flybackApplyPage',
		data(){
	      return {
	      	// 查询条件
	        listQuery:{
	        	projCodeName:'',
	        	pmName:'',
	        	status:'',
	        	currentPage:1, // 当前页
	        	pageSize:5, // 每页数据
          		filter:'0' // 是否需要用户过滤 1：需要 0：不需要
	        },
	      	refreshing: false,
	      	loading: false,
	      	listData:[],

	      	filterOpen: false,
	      	trigger: null
	      }
		},
		created(){
			// 加载数据
			this.loadData();
		},
		computed:{
		},
		mounted: function(){
			 this.trigger = this.$refs.filterBtn.$el;
		},
		methods:{
            //时间格式化
            dateFormatter(date) {
                return dateFormat(date);
            },
            flybackTypeSet(typeCode){
                var type = "";
                if(typeCode === '001'){
                    type='到达';
                }else if(typeCode === '002'){
                    type='返回';
                }else if(typeCode === '003'){
                    type='往返';
                }
                return type;
            },
			// 返回
			goback(){
				// 返回工作台
				this.$router.push({ name:'workbench'});
			},
			// 筛选
			filter(){
				this.filterOpen = !this.filterOpen; 
			},
			// 查找
			searchEvent(event){
				if(event.keyCode == 13){
					this.listQuery.currentPage=1;
					this.loadData();
				}
			},
			// 清空条件
			clearFilter(){
				this.listQuery.projCodeName='';
				this.listQuery.pmName='';
				this.listQuery.status='';
				// 当前页重置
				this.listQuery.currentPage=1;

				this.loadData();
			},
			// 数据刷新(下拉)
		    refresh () {
		      this.refreshing = true;
		      this.$refs.container.scrollTop = 0;

		      this.listQuery.currentPage= 1;
		      setTimeout(() => {
		        // refreshing=true 的情况下加载
		        this.loadData();
		        this.refreshing = false;
		      }, 600);
		    },
		    // 数据加载(上拉)
		    load(){
		      this.loading = true;
		      setTimeout(() => {
		        this.listQuery.currentPage++;
		        // 加载
		        this.loadData2();
		        this.loading = false;
		      }, 600);
		    },
		    // 加载
		    loadData(){
		        var condition = {'condition':JSON.stringify(this.listQuery)};
		        page(condition).then(response => {
	        		// 刷新情况下
	          		this.listData = response.list;
		        });
		    },
		    // 加载数据
		    loadData2(){
		        var condition = {'condition':JSON.stringify(this.listQuery)};
		        page(condition).then(response => {
	        		// 加载数据情况下
	        		var data = response.list;
	        		for(var i=0;i<data.length;i++){
	        			this.listData.push(data[i]);
	        		}
		        });
		    },
		    // 进入明细
		    itemClick(row){
                this.$router.push({ name:'差旅详细',params:{mainId:row.id}});
		    }
		}
	}



// WEBPACK FOOTER //
// ./src/view/flyback/flybackApplyList.vue